// Share text templates per apartment – for "Link kopieren / WhatsApp / E-Mail"
// buttons on the public landing page and the admin dashboard.

// apartmentId -> URL slug (must match the routes in App.js / sitemap.xml)
export const APARTMENT_SLUGS = {
    erdgeschoss: "erdgeschoss",
    obergeschoss: "obergeschoss",
    penthouse: "penthouse",
    "loft-maisonette": "loft",
};

// E-Mail subject lines per apartment
const SUBJECTS = {
    erdgeschoss:
        "Eigentumswohnung Wiesbaden-Biebrich · 3-Zimmer Erdgeschoss · G21 Neubau",
    obergeschoss:
        "Eigentumswohnung Wiesbaden-Biebrich · 4-Zimmer Obergeschoss · G21 Neubau",
    penthouse:
        "Penthousewohnung Wiesbaden-Biebrich · 18 m² Dachterrasse · G21 Neubau",
    "loft-maisonette":
        "Loft-Maisonette Wiesbaden-Biebrich · Hinterhaus · G21 Neubau",
};

// Friendly long-form mail body, "{url}" is replaced at runtime
const MAIL_BODIES = {
    erdgeschoss: `Hallo,

vielleicht ist diese Eigentumswohnung in Wiesbaden-Biebrich etwas für Sie / dich:

Erdgeschosswohnung · G21 Neubau · Gaugasse 21, 65203 Wiesbaden
• 3 Zimmer · 78,75 m² · barrierefreier Zugang
• Private Terrasse · eigener Kellerraum
• PKW-Carport im Hintergebäude · Fahrradständer im Innenhof
• Effizienzhaus 40 · KfW-förderfähig · eigene Wärmepumpe
• 2 kW PV-Anlage inkl. Speicher · Wallbox optional
• Kaufpreis ab 472.000 € (zzgl. Stellplatz 29.000 €)

Alle Bilder, Grundriss und das Anfrageformular finden Sie hier:
{url}

Direkt vom Bauträger – G21 Projekt GmbH, Wiesbaden.`,
    obergeschoss: `Hallo,

vielleicht ist diese Eigentumswohnung in Wiesbaden-Biebrich etwas für Sie / dich:

Obergeschosswohnung · G21 Neubau · Gaugasse 21, 65203 Wiesbaden
• 4 Zimmer · 116,86 m² · familienfreundlich
• Zwei Bäder · Balkon · eigener Kellerraum
• PKW-Carport im Hintergebäude · Fahrradständer im Innenhof
• Effizienzhaus 40 · KfW-förderfähig · eigene Wärmepumpe
• 2 kW PV-Anlage inkl. Speicher · Wallbox optional
• Kaufpreis ab 783.000 € (zzgl. Stellplatz 29.000 €)

Alle Bilder, Grundriss und das Anfrageformular finden Sie hier:
{url}

Direkt vom Bauträger – G21 Projekt GmbH, Wiesbaden.`,
    penthouse: `Hallo,

vielleicht ist diese Penthousewohnung in Wiesbaden-Biebrich etwas für Sie / dich:

Penthouse · G21 Neubau · Gaugasse 21, 65203 Wiesbaden
• 3 Zimmer · 114,27 m² Wohnfläche
• 18 m² eigene Dachterrasse · klassische Dachform mit Flachbereich
• Optionaler Kaminanschluss · 2 kW PV-Anlage mit Speicher inkl. · Wallbox optional
• Eigener Kellerraum · PKW-Carport · Fahrradständer im Innenhof
• Effizienzhaus 40 · KfW-förderfähig
• Kaufpreis ab 823.000 € (zzgl. Stellplatz 29.000 €)

Alle Bilder, Grundriss und das Anfrageformular finden Sie hier:
{url}

Direkt vom Bauträger – G21 Projekt GmbH, Wiesbaden.`,
    "loft-maisonette": `Hallo,

vielleicht ist diese Loft-Maisonette in Wiesbaden-Biebrich etwas für Sie / dich:

Loft-Maisonette · Hinterhaus · G21 Neubau · Gaugasse 21, 65203 Wiesbaden
• 4 Zimmer · 116,62 m² · Maisonette über zwei Ebenen
• Loggia + private Dachterrasse · Loft-Charakter
• Ruhige Lage im Innenhof
• Eigener Kellerraum · PKW-Carport · Fahrradständer im Innenhof
• Effizienzhaus 40 · KfW-förderfähig · eigene Wärmepumpe
• 2 kW PV-Anlage inkl. Speicher · Wallbox optional
• Kaufpreis ab 723.000 € (zzgl. Stellplatz 29.000 €)

Alle Bilder und das Anfrageformular finden Sie hier:
{url}

Direkt vom Bauträger – G21 Projekt GmbH, Wiesbaden.`,
};

// Short, snappy WhatsApp text (one line + URL)
const WHATSAPP_TEXTS = {
    erdgeschoss:
        "Eigentumswohnung Wiesbaden-Biebrich – 3-Zimmer Erdgeschoss, barrierefrei, 78,75 m² mit Terrasse, ab 472.000 €. Effizienzhaus 40, direkt vom Bauträger. Alle Infos: {url}",
    obergeschoss:
        "Eigentumswohnung Wiesbaden-Biebrich – 4-Zimmer Obergeschoss, 116,86 m², Balkon, 2 Bäder, Carport, ab 783.000 €. Effizienzhaus 40, direkt vom Bauträger. Alle Infos: {url}",
    penthouse:
        "Penthousewohnung Wiesbaden-Biebrich – 114 m² mit 18 m² Dachterrasse, Effizienzhaus 40, ab 823.000 €. Direkt vom Bauträger. Alle Infos: {url}",
    "loft-maisonette":
        "Loft-Maisonette Wiesbaden-Biebrich – Hinterhaus, 116 m² über zwei Ebenen, Loggia + Dachterrasse, ab 723.000 €. Effizienzhaus 40, direkt vom Bauträger. Alle Infos: {url}",
};

const PRODUCTION_BASE = "https://neubau-kaufen-wiesbaden.de";

export const getShareBaseUrl = () =>
    typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : PRODUCTION_BASE;

export const buildShare = (apartmentId, baseUrl) => {
    const slug = APARTMENT_SLUGS[apartmentId];
    if (!slug) return null;
    const base = baseUrl || getShareBaseUrl();
    const url = `${base}/wohnung/${slug}`;
    const subject = SUBJECTS[apartmentId];
    const mailBody = (MAIL_BODIES[apartmentId] || "").replaceAll("{url}", url);
    const whatsappText = (WHATSAPP_TEXTS[apartmentId] || "").replaceAll(
        "{url}",
        url,
    );
    return { slug, url, subject, mailBody, whatsappText };
};
